export const APP_TRANSLATION_TEMPLATE = "template";
export const TRANSLATE_LOADER_PREFIX = "assets/i18n/";
export const TRANSLATE_LOADER_SUFFIX = ".json";
